if (
  process.isClient // Must be used because Node doesn't have NodeList and it will break our server.
  && typeof NodeList !== undefined
  && NodeList.prototype
  && !NodeList.prototype.forEach
) {
  Object.defineProperty(NodeList.prototype, 'forEach', {
    value: Array.prototype.forEach
  });
}